import React, { createContext } from 'react'
import propTypes from 'prop-types'

export const ApplicationContext = createContext({
  user: null,
  trackingDetails: null,
  theme: null
})

export const ApplicationProvider = ({ children, value }) => {
  return (
    <ApplicationContext.Provider value={value}>
      {children}
    </ApplicationContext.Provider>
  )
}

ApplicationProvider.propTypes = {
  value: propTypes.shape({
    user: propTypes.object,
    trackingDetails: propTypes.object.isRequired,
    theme: propTypes.object.isRequired,
    featureConfig: propTypes.object,
    featureToggles: propTypes.object,
    permissions: propTypes.arrayOf(propTypes.string)
  })
}
